import React from 'react';

export default class GetAge extends React.Component {
    
    constructor() {
        super();
    
        this.state = {
          componentData: ''
        };
      }

  componentDidMount() {
    var today = new Date();
    var birthDate = new Date(this.props.birth);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
        console.log(age);
        this.setState({
            componentData: age
          })
        
    }

    
  }

  render() {
    return (
      <>
        <span>{this.state.componentData}</span>
      </>
    )
  }
}